import { gql } from "apollo-boost";

export const fragments = {
  Contract: gql`
    fragment JobContractsContract on Contract {
      id
      description
      amountInCents
      effectiveDate
      cancelled
      attachment {
        id
        versions {
          original
        }
      }
    }
  `
};

export default gql`
  query JobContracts($jobId: ID!) {
    contracts(jobId: $jobId) {
      ...JobContractsContract
    }
  }
  ${fragments.Contract}
`;



// WEBPACK FOOTER //
// ./src/queries/JobContracts.js